import elementDataStore from 'element-data-store';
import scrollToElement from 'scroll-to-element';
import { fire } from 'delegated-events';
import helpers from './helpers.js';

/*
===================================================================
EXPANDABLE LINKS
===================================================================
*/
export default (function () {
  return {
    init() {
      const expandLinks = document.querySelectorAll('.js-expand-link');
	  const currentPath = document.location;
	  const currentPathHash =  String(currentPath).split('#');


      helpers.forEach(expandLinks, (i, el) => {
        const targ = el.getAttribute('data-targ') || el.getAttribute('href');
        const target = document.querySelector(targ);
        const direction = el.getAttribute('data-direction') || 'both';
        const targetAnchor = el.querySelector('.accordion__anchor');

        if(targetAnchor) {
          const anchorLink = targetAnchor.getAttribute('id');

          // check if id of the el is the same as the hash in the url, click on it to open the accordion
          if(anchorLink === currentPathHash[currentPathHash.length - 1]) {
			  setTimeout(() => {
              	fire(el, 'click');
			  }, 100);
          }
        }

        let hideClass = el.getAttribute('data-mobile-only') === 'true' ? 'u-hide@s' : 'u-hide';
        hideClass = el.getAttribute('data-small-medium-screens-only') === 'true' ? 'u-hide@s u-hide@ms' : hideClass;
        hideClass = el.getAttribute('data-tablet-only') === 'true' ? 'u-hide@s u-hide@m' : hideClass;
        hideClass = el.getAttribute('data-menubreak-only') === 'true' ? 'u-hide@undermenu' : hideClass;

        if (target == null) return;

        // Show if contains error messages
        if (target.querySelectorAll('.error, .field-validation-error').length) {
          el.classList.add('is-open');
          helpers.setAttributes(el, { 'aria-expanded': 'true' });
        }

        if (direction !== 'close') {
          if (el.classList.contains('is-open')) {
            helpers.addClass(target, 'is-shown');
            el.setAttribute('aria-expanded', 'true');
          } else {
            helpers.addClass(el, 'is-closed');
            helpers.addClass(target, 'is-hidden');
            helpers.addClass(target, hideClass);
            helpers.setAttributes(el, { 'aria-expanded': 'false' });
            // helpers.addClass(target, 'u-hide');
          }
        }

        // add a clsss to the target so we can easily identify it
        helpers.addClass(target, 'js-expand-target');

        // all the expand/contract links are kept in an array on the item so we can track state
        const links = elementDataStore.get(target, 'links') || [];
        links.push(el);
        elementDataStore.set(target, 'links', links);
      });

      helpers.forEach(expandLinks, (i, el) => {
        el.addEventListener('keypress', (e) => {
          if (e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            fire(el, 'click');
          }
        });

        el.addEventListener('click', (e) => {
          e.preventDefault();
          const targ = el.getAttribute('data-targ') || el.getAttribute('href');
          const target = document.querySelector(targ);
          const direction = el.getAttribute('data-direction') || 'both';

          let hideClass = el.getAttribute('data-mobile-only') === 'true' ? 'u-hide@s' : 'u-hide';
          hideClass = el.getAttribute('data-small-medium-screens-only') === 'true' ? 'u-hide@s u-hide@ms' : hideClass;
          hideClass = el.getAttribute('data-tablet-only') === 'true' ? 'u-hide@s u-hide@m' : hideClass;
          hideClass = el.getAttribute('data-menubreak-only') === 'true' ? 'u-hide@undermenu' : hideClass;

          if (target.matches('.is-hidden')
          && el.closest('.js-expand-wrapper') != null
          && el.closest('.js-expand-wrapper').getAttribute('data-mode') === 'single') {
            const wrapper = el.closest('.js-expand-wrapper');
            const content = wrapper.querySelectorAll('.js-expand-target');
            const headers = wrapper.querySelectorAll('.js-expand-link');

            helpers.addClass(content, 'is-hidden u-hide');
            helpers.removeClass(content, 'is-shown');
            helpers.removeClass(headers, 'is-open');
            helpers.addClass(headers, 'is-closed');
            helpers.setAttributes(headers, { 'aria-expanded': 'false' });
          }

          if (direction === 'open' && target.matches('.is-shown')) {
            return;
          }

          if (direction === 'close' && target.matches('.is-hidden')) {
            return;
          }

          helpers.toggleClass(target, 'is-hidden');
          helpers.toggleClass(target, hideClass);
          helpers.toggleClass(target, 'is-shown');

          helpers.forEach(elementDataStore.get(target, 'links'), (index, element) => {
            helpers.toggleClass(element, 'is-closed');
            helpers.toggleClass(element, 'is-open');

            const expanded = element.getAttribute('aria-expanded') === 'false' ? 'true' : 'false';
            helpers.setAttributes(el, { 'aria-expanded': expanded });

            if (element.hasAttribute('data-open-text') && element.hasAttribute('data-closed-text')) {
              element.textContent = element.matches('.is-open') ? element.getAttribute('data-open-text') : element.getAttribute('data-closed-text');
            }
          });

          fire(window, 'resize');

          // if after clicking on an element and closing other headers this one is no longer on screen then show it
          if (el.closest('.js-accordion') !== null && el.closest('.js-accordion').getAttribute('data-scroll') === 'true') {
            scrollToElement(el, {
              duration: 500,
              ease: 'in-out-quad',
            });
          }
        });
      });
    },
  };
}());